export const File = [
  {
    type: 'item',
    text: 'Kısayol Oluştur',
    disable: true,
  },
  {
    type: 'item',
    text: 'Sil',
    disable: true,
  },
  {
    type: 'item',
    text: 'Yeniden Adlandır',
    disable: true,
  },
  {
    type: 'item',
    disable: true,
    text: 'Özellikler',
  },
  {
    type: 'separator',
  },
  {
    type: 'item',
    text: 'Kapat',
  },
];
const Edit = [
  {
    type: 'item',
    disable: true,
    text: 'Geri Al',
    hotkey: 'Ctrl+Z',
  },
  {
    type: 'separator',
  },
  {
    type: 'item',
    disable: true,
    text: 'Kes',
    hotkey: 'Ctrl+X',
  },
  {
    type: 'item',
    disable: true,
    text: 'Kopyala',
    hotkey: 'Ctrl+C',
  },
  {
    type: 'item',
    disable: true,
    text: 'Yapıştır',
    hotkey: 'Ctrl+V',
  },
  {
    type: 'item',
    disable: true,
    text: 'Kısayolu Yapıştır',
  },
  {
    type: 'separator',
  },
  {
    type: 'item',
    text: 'Klasöre Kopyala...',
    disable: true,
  },
  {
    type: 'item',
    text: 'Klasöre Taşı...',
    disable: true,
  },
  {
    type: 'separator',
  },
  {
    type: 'item',
    text: 'Tümünü Seç',
    hotkey: 'Ctrl+A',
  },
  {
    type: 'item',
    text: 'Seçimi Tersine Çevir',
  },
];

const View = [
  {
    type: 'menu',
    position: {
      left: 'calc(100% - 4px)',
      top: '-3px',
    },
    text: 'Araç Çubukları',
    items: [
      {
        type: 'item',
        symbol: 'check',
        text: 'Standart Düğmeler',
      },
      {
        type: 'item',
        symbol: 'check',
        text: 'Adres Çubuğu',
      },
      {
        type: 'item',
        symbol: 'check',
        text: 'Bağlantılar',
      },
      {
        type: 'separator',
      },
      {
        type: 'item',
        symbol: 'check',
        text: 'Araç Çubuklarını Kilitle',
      },
      {
        type: 'item',
        text: 'Özelleştir...',
      },
    ],
  },
  {
    type: 'item',
    symbol: 'check',
    text: 'Durum Çubuğu',
  },
  {
    type: 'menu',
    position: {
      left: 'calc(100% - 4px)',
      top: '-3px',
    },
    text: 'Gezgin Çubuğu',
    items: [
      {
        type: 'item',
        text: 'Ara',
        hotkey: 'Ctrl+E',
      },
      {
        type: 'item',
        text: 'Favoriler',
        hotkey: 'Ctrl+I',
      },
      {
        type: 'item',
        text: 'Geçmiş',
        hotkey: 'Ctrl+H',
      },
      {
        type: 'item',
        text: 'Dosyalar',
      },
      {
        type: 'separator',
      },
      {
        type: 'item',
        text: 'Günün İpucu',
      },
    ],
  },
  {
    type: 'separator',
  },
  {
    type: 'item',
    text: 'Küçük Resimler',
  },
  {
    type: 'item',
    text: 'Simge Görünümü',
    symbol: 'circle',
  },
  {
    type: 'item',
    text: 'Simgeler',
  },
  {
    type: 'item',
    text: 'Liste',
  },
  {
    type: 'item',
    text: 'Detaylar',
  },
  {
    type: 'separator',
  },
  {
    type: 'menu',
    position: {
      left: 'calc(100% - 4px)',
      top: '-3px',
    },
    text: 'Simgeleri Düzenle',
    items: [
      {
        type: 'item',
        text: 'Ad',
      },
      {
        type: 'item',
        text: 'Tür',
        symbol: 'circle',
      },
      {
        type: 'item',
        text: 'Toplam Boyut',
      },
      {
        type: 'item',
        text: 'Boş Alan',
      },
      {
        type: 'item',
        text: 'Yorumlar',
      },
      {
        type: 'separator',
      },
      {
        type: 'item',
        text: 'Gruplar Halinde Göster',
        symbol: 'check',
      },
      {
        type: 'item',
        text: 'Otomatik Düzenle',
      },
      {
        type: 'item',
        text: 'Izgaraya Hizala',
      },
    ],
  },
  {
    type: 'separator',
  },
  {
    type: 'item',
    text: 'Ayrıntıları Seç...',
  },
  {
    type: 'menu',
    position: {
      left: 'calc(100% - 4px)',
      top: '-3px',
    },
    text: 'Git',
    items: [
      {
        type: 'item',
        disable: true,
        text: 'Geri',
        hotkey: 'Alt+Left Arrow',
      },
      {
        type: 'item',
        disable: true,
        text: 'İleri',
        hotkey: 'Alt+Right Arrow',
      },
      {
        type: 'item',
        text: 'Bir Üst Düzeye Git',
      },
      {
        type: 'separator',
      },
      {
        type: 'item',
        text: 'Ana Sayfa',
        hotkey: 'Alt+Home',
      },
      {
        type: 'separator',
      },
      {
        type: 'item',
        text: 'Bilgisayarım',
        symbol: 'check',
      },
    ],
  },
  {
    type: 'item',
    text: 'Yenile',
  },
];
const Favorites = [
  {
    type: 'item',
    text: 'Favorilere Ekle…',
  },
  {
    type: 'item',
    text: 'Favorileri Düzenle…',
  },
  {
    type: 'separator',
  },
  {
    type: 'menu',
    symbol: 'folder',
    position: {
      left: 'calc(100% - 4px)',
      top: '-3px',
    },
    text: 'Bağlantılar',
    items: [
      {
        type: 'item',
        text: 'Bağlantıları Özelleştir',
        symbol: 'ie-paper',
      },
      {
        type: 'item',
        text: 'Hotmail',
        symbol: 'ie-paper',
      },
      {
        type: 'item',
        text: 'Windows',
        symbol: 'ie-paper',
      },
      {
        type: 'item',
        text: 'Windows Marketplace',
        symbol: 'ie-book',
      },
      {
        type: 'item',
        text: 'Windows Medya',
        symbol: 'ie-paper',
      },
    ],
  },
  {
    type: 'item',
    text: 'MSN.com',
    symbol: 'ie-paper',
  },
  {
    type: 'item',
    text: 'Radyo İstasyonu Rehberi',
    symbol: 'ie-paper',
  },
];
const Tools = [
  {
    type: 'item',
    text: 'Ağ Sürücüsünü Bağla…',
  },
  {
    type: 'item',
    text: 'Ağ Sürücüsünün Bağlantısını Kes…',
  },
  {
    type: 'item',
    text: 'Eşitle…',
  },
  {
    type: 'separator',
  },
  {
    type: 'item',
    text: 'Klasör Seçenekleri…',
  },
];
const Help = [
  {
    type: 'item',
    text: 'Yardım ve Destek Merkezi',
  },
  {
    type: 'separator',
  },
  {
    type: 'item',
    text: 'Bu Windows kopyası yasal mı?',
  },
  {
    type: 'item',
    text: 'Windows Hakkında',
  },
];
export default { File, Edit, View, Favorites, Tools, Help };
